<template>
    <AuthenticatedLayout
        :title="__('Gallery')"
        :footerContainer="false"
    >
    <div class="max-w-screen-xl mx-auto">
        <div class="bg-white shadow-md rounded-md md:p-6 p-3 mb-6">
            <Heading
                :label="__('Gallery')"
                class="text-center justify-center"
                :description="__('Gallery of products made by the company')"
                type="h1"
            />
        </div>
        <div class="bg-gray-900 shadow-md rounded-md md:p-6 p-3">
            <div class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-6">
                <template v-if="gallery && gallery.value.length">
                <div
                    class="rounded-md shadow-md overflow-hidden group relative gallery-card h-60 cursor-pointer"
                    v-for="(item, key) in gallery.value"
                    :key="key"
                    @click="active.fullscreen = true; active.image = item.link"
                >
                    <img
                        :src="item.link"

                        class="group-hover:scale-125 group-hover:rotate-6 scale-100 w-full h-full object-center object-cover transform transition duration-500"
                    />
                </div>
                </template>
                <p class="text-xl text-gray-200 text-center col-span-full" v-else>{{__('Gallery is empty')}}</p>
            </div>
        </div>
    </div>
        <div class="fixed inset-0 bg-gray-900 bg-opacity-75 z-50 flex justify-center items-center"
            v-if="active.fullscreen"
            @click="closeModal($event)"
        >
            <button class="text-2xl bg-red-700 hover:bg-red-800 text-gray-200 px-2 rounded-md absolute top-5 right-5 font-bold" @click="active.show = false;">X</button>
            <transition
                enter-active-class="transition duration-300"
                enter-from-class="transform opacity-0 scale-50"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition duration-300"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-50"

                mode="out-in"
                @after-leave="active.fullscreen = false;"
            >
                <div class="w-5/6 h-5/6 flex justify-center items-center"
                    v-if="active.show"
                >
                    <img :src="active.image"  class="max-w-full max-h-full preview" />
                </div>
            </transition>
        </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import InputLabel from 'UI/InputLabel';
import { ref } from '@vue/reactivity';
import { watch } from '@vue/runtime-core';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
        InputLabel,
    },
    props: {
        auth: Object,
        loggedin: Boolean,
        gallery: [Array, Object]
    },
    setup(props) {
        const active = ref({
            image: null,
            fullscreen: false,
            show: false,
        })

        function closeModal(ev) {
            if(!$(ev.target).hasClass('preview')) active.value.show = false;
        }

        watch(() => active.value.fullscreen, (val, oldVal) => {
            if(val) setTimeout(() => { active.value.show = true }, 100);
        });

        return {
            active,

            closeModal
        }
    },

}
</script>
<style lang="postcss" scoped>
.gallery-card::before {
    content: '';
    @apply absolute inset-0 bg-gray-900 bg-opacity-40 z-10 transition duration-500;
}
.gallery-card:hover::before {
    @apply bg-opacity-0;
}
</style>
